
export default {
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
  computed: {
    cards() {
      return [
        {
          title: this.slice.primary.lh_title,
          content: this.slice.primary.lh_content,
          ctaText: this.slice.primary.lh_cta,
          ctaLink: this.slice.primary.lh_href,
        },
        {
          title: this.slice.primary.rh_title,
          content: this.slice.primary.rh_content,
          ctaText: this.slice.primary.rh_cta,
          ctaLink: this.slice.primary.rh_href,
        },
      ]
    },
  },
}
